module.exports = __webpack_public_path__ + "img/slider-home-2@2x.9ffe9865.png";